import { groupBy, uniqueId } from 'lodash';
import moment from 'moment';
import { defaultFilterList, optionFilterList, otherFilterList, blobRequestArr } from '@/constant';

export default function () {
  return {
    /**
     * 倒计时
     * @param timer
     * @param count
     * @param show
     */
    countDown(countData) {
      const TIME_COUNT = 60
      if (!countData.timer) {
        countData.count = TIME_COUNT
        countData.show = false
        countData.timer = setInterval(() => {
          if (countData.count > 0 && countData.count <= TIME_COUNT) {
            countData.count--
          } else {
            countData.show = true
            clearInterval(countData.timer)
            countData.timer = null
          }
        }, 1000)
      }
    },
    /**
     * 获取当前状态
     **/
    getState() {
      var stateText = localStorage.getItem('$state') || '{}'
      return JSON.parse(stateText)
    },
    /**
     * 设置当前状态
     **/
    setState(state) {
      state = state || {}
      localStorage.setItem('$state', JSON.stringify(state))
    },
    checkEmail(email) {
      email = email || ''
      return (email.length > 3 && email.indexOf('@') > -1)
    },
    /**
     * 获取应用本地配置
     **/
    setSettings(settings) {
      settings = settings || {}
      localStorage.setItem('$settings', JSON.stringify(settings))
    },
    /**
     * 设置应用本地配置
     **/
    getSettings() {
      var settingsText = localStorage.getItem('$settings') || '{}'
      return JSON.parse(settingsText)
    },
    /**
     * 获取当前时间，格式： yyyyMMddHHmmss
     */
    getNowFormatDateTimeStr() {
      var date = new Date()
      var seperator1 = ''
      var seperator2 = ''
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
        date.getHours() + seperator2 + date.getMinutes() +
        seperator2 + date.getSeconds()
      return currentdate
    },
    /**
     * 获取当前时间，格式： yyyy-MM-dd HH:mm:ss
     */
    getNowFormatDateTime() {
      var date = new Date()
      var seperator1 = '-'
      var seperator2 = ':'
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
        ' ' + date.getHours() + seperator2 + date.getMinutes() +
        seperator2 + date.getSeconds()
      return currentdate
    },
    /**
     * 获取当前时间，格式： yyyy-MM-dd
     */
    getNowFormatDate(d) {
      var date = d ? new Date(d) : new Date();
      var seperator1 = '-'
      // var seperator2 = ':'
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    /**
     * value:秒
     * 时间转换，格式：H小时M分S秒
     */
    formatSeconds(value) {
      var theTime = parseInt(value) // 秒
      var theTime1 = 0 // 分
      var theTime2 = 0 // 小时
      if (theTime > 60) {
        theTime1 = parseInt(theTime / 60)
        theTime = parseInt(theTime % 60)
        if (theTime1 > 60) {
          theTime2 = parseInt(theTime1 / 60)
          theTime1 = parseInt(theTime1 % 60)
        }
      }
      var result = '' + parseInt(theTime) + '秒'
      if (theTime1 > 0) {
        result = '' + parseInt(theTime1) + '分' + result
      }
      if (theTime2 > 0) {
        result = '' + parseInt(theTime2) + '小时' + result
      }
      return result
    },
    IsMobile(mobile) {
      var re = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/
      return re.test(mobile)
    },
    getSignature(Userid, time) {
      var str = 'userPhone=' + Userid + '&timestamp=' + time
      console.log('signstr:' + str)
      var sign = str // hex_md5(str).toLowerCase()
      console.log('sign:' + sign)
      return sign
    },
    CreateRequestObj(requestdata, time) {
      if (!requestdata.userid) {
        requestdata.userid = this.getState().userid
      }

      var UrcRequest = {
        requestData: JSON.stringify(requestdata),
        signature: this.getSignature(this.getState().phone, time),
        timestamp: time
      }
      return UrcRequest
    },
    GetDateStr(AddDayCount) {
      var dd = new Date()
      dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 // 获取当前月份的日期
      var d = dd.getDate()
      return y + '-' + m + '-' + d
    },
    /**
     * 日期转时间戳
     **/
    dateToTimestamp(da) {
      let date = da ? new Date(da) : new Date();
      return date.getTime()
    },
    timeToNow(time) {
      let date = new Date()
      let nowTime = date.getTime()
      let toNow = nowTime - time
      return Math.ceil(toNow / (1000 * 60 * 60 * 24))
    },
    changeTime(da = '1970-01-01 00:00:00') {
      let time = this.dateToTimestamp(da)
      let nowTime = new Date().getTime()
      let now = nowTime - time
      let date = ''
      switch (true) {
        case (now / (1000 * 60 * 60)) < 1:
          date = Math.floor(now / (1000 * 60)) + '分钟前'
          break
        case (now / (1000 * 60 * 60)) < 24 && (now / (1000 * 60 * 60)) > 1:
          date = Math.floor(now / (1000 * 60 * 60)) + '小时前'
          break
        case (now / (1000 * 60 * 60)) > 24 && (now / (1000 * 60 * 60)) < 48:
          date = '1天前'
          break
        case (now / (1000 * 60 * 60)) > 48 && (now / (1000 * 60 * 60)) < 72:
          date = '2天前'
          break
        case (now / (1000 * 60 * 60)) > 72 && (now / (1000 * 60 * 60)) < 96:
          date = '3天前'
          break
        case (now / (1000 * 60 * 60)) > 96:
          date = da.match(/(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)-(0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8])))/)[0]
          break
      }
      console.log(date)
      return date
    },
    mapToObject(strMap) {
      let obj = Object.create(null)
      for (let [k, v] of strMap) {
        obj[k] = v
      }
      return obj
    },
    resetData(data) {
      for (let item of data) {
        if (item.children) {
          this.resetData(item.children)
        }
        item.selected = false
      }
      return data
    },
    arrayToTree(sNodes, options = {}) {
      let i, l;
      const key = options.key || 'id';
      const parentKey = options.parentKey || 'parentId';
      const childKey = options.childKey || 'children';
      if (!key || key == '' || !sNodes) return [];

      const arr = JSON.parse(JSON.stringify(sNodes));

      if (arr instanceof Array) {
        const r = [];
        const tmpMap = [];
        for (i = 0, l = arr.length; i < l; i++) {
          tmpMap[arr[i][key]] = arr[i];
        }
        for (i = 0, l = arr.length; i < l; i++) {
          if (tmpMap[arr[i][parentKey]] && arr[i][key] != arr[i][parentKey]) {
            if (!tmpMap[arr[i][parentKey]][childKey]) tmpMap[arr[i][parentKey]][childKey] = [];

            tmpMap[arr[i][parentKey]][childKey].push(arr[i]);
          } else {
            r.push(arr[i]);
          }
        }
        return r;
      } else {
        return [arr];
      }
    },
    treeToArray(tree, options = {}) {
      const {
        level = 0, fullParentId = ''
      } = options;
      const arr = [];

      tree.forEach(item => {
        arr.push({
          ...item,
          level,
          fullParentId
        });
        if ((item.children || []).length > 0) {
          const childFullParentId = fullParentId ? [...fullParentId.split('/'), item.id].join('/') : item.id;
          arr.push(...this.treeToArray(item.children, {
            level: level + 1,
            fullParentId: childFullParentId
          }));
        }
      });

      return arr;
    },
    formatFilterWord(keyword = '') {
      // const reg = /([\u4e00-\u9fa5\d]+)/g;
      const reg = /([(\u4e00-\u9fa5\d)(，。（）()\[\]【】{}！,.\!、)]+)/g;
      const words = [];
      let setences = keyword.replace(/^[+|&]+|[-+|&]+$/g, '');

      setences = setences
        .replace(/\|/gi, 'OR')
        .replace(/and/g, 'AND')
        .replace(/or/g, 'OR')
        .replace(/\\s+且\\s+/, 'AND')
        .replace(/\\s+或\\s+/, 'OR')
        .split(reg);


      for (const word of setences) {
        if (reg.test(word)) {
          words.push(`("${word}")`);
        } else {
          words.push(word);
        }
      }
      return words.join('');
    },
    fetchCourseFilterTips({ instrumentType, filterList, paragraphArr, hideFilterName }) {
      const tips = [];
      const colon = ' : ';
      if (instrumentType) {
        const filterName = hideFilterName ? '' : `文书类型${colon}`;
        tips.push({ filterItem: { name: '文书类型' }, tipText: `${filterName}${instrumentType}` });
      }
      filterList.forEach(filterItem => {
        let tipText = '';
        const filterName = hideFilterName ? '' : `${filterItem.name}${colon}`;
        if (filterItem.inputType == 'version' && filterItem.value) {
          tipText = `${filterName}${filterItem.value}`;
        } else if (filterItem.key == 'fullreferencetype' && filterItem.value) {
          tipText = `${filterName}${filterItem.value}`;
        } else if (filterItem.inputType == 'matchSelect' && ['全文检索', '引用法条', '案由'].includes(filterItem.name)) {
          if (filterItem.name === '全文检索') {
            tipText = this.fullTextShowHandel(filterItem, paragraphArr).filter(i => i.text);
          }
          if (filterItem.name === '引用法条') {
            const paraObj = groupBy(filterItem.result, 'keyword');
            tipText = [];
            Object.keys(paraObj).forEach(paragraphKey => {
              const contentArr = paraObj[paragraphKey];
              let text = paragraphKey;
              if (text) {
                text = `${text} `;
              }
              contentArr.forEach((val, idx) => {
                let valText = val.value;
                if (idx !== 0 && valText) {
                  valText = `${filterItem.type === 'and' ? ' + ' : ' | '} ${valText}`;
                }
                text = `${text}${valText}`;
              });
              if (text) {
                tipText.push({ text, contentArr });
              }
            });
          }
          if (filterItem.name === '案由') {
            const item = (filterItem.result || []).filter(paraItem => paraItem.value.length);
            if (item.length === 0) {
              return;
            }
            const val = item.map(i => {
              if(i.showValue.length > 1){
                return `(${i.showValue.map(item => item.name).join(' | ')})`;
              }else{
                return `${i.showValue.map(item => item.name).join(' | ')}`;
              }
            });

            tipText = `${filterName}${val.join(filterItem.type === 'and' ? ' + ' : ' | ')}`;
            // 如果拆分成多个
            // tipText = item.map(i => {
            //   return { text:`${i.showValue.map(item => item.name).join(' | ')}`};
            // });
          }
        } else if (['审理程序', '地域及法院'].includes(filterItem.name) && filterItem.value.length > 0) {
          tipText = `${filterName}${filterItem.showValue.map(item => item.name).join(' / ')}`;
        } else if (filterItem.inputType == 'matchSelect' && filterItem.name == '引用法条') {
          filterItem.result.forEach(contentItem => {
            if (contentItem.keyword) {
              tipText = `${filterName}${contentItem.keyword}`;
              if (contentItem.value) {
                tipText = `${tipText} ${contentItem.value}`;
              }
            }
          });
        } else if (filterItem.inputType === 'province_city_cascader' && (filterItem.value || []).length > 0) {
          tipText = `${filterName}`;
          filterItem.value.forEach((val, i) => {
            tipText = `${tipText}${val[val.length - 1]}`;
            if (i !== filterItem.value.length - 1) {
              tipText = `${tipText}/`;
            }
          });
        } else if (filterItem.key === 'mulit_personal_crime') {
          const key = Object.keys(filterItem.value)
            .map(i => {
              return Number(filterItem.value[i]);
            })
            .join('');
          if (key > 0) {
            tipText = `${filterName}${this.crimeEnum(key)}`;
          }
        } else if (
          (filterItem.inputType == 'select' || filterItem.inputType == 'input') &&
          (filterItem.value || []).length > 0
        ) {
          tipText = `${filterName}`;
          if (Array.isArray(filterItem.value)) {
            filterItem.value.forEach((val, i) => {
              tipText = `${tipText}${val}`;
              if (i !== filterItem.value.length - 1) {
                tipText = `${tipText}|`;
              }
            });
          } else {
            tipText = `${tipText}${filterItem.value}`;
          }
        } else if (
          filterItem.inputType == 'date' &&
          filterItem.value.length > 0 &&
          (filterItem.value[0] || filterItem.value[1])
        ) {
          tipText = `${filterName}`;
          if (filterItem.value[0]) {
            tipText = `${tipText}${moment(filterItem.value[0]).format('YYYY-MM-DD')}`;
          }
          if (filterItem.value[1]) {
            if (tipText !== `${filterName}`) {
              tipText = `${tipText} - `;
            }
            tipText = `${tipText}${moment(filterItem.value[1]).format('YYYY-MM-DD')}`;
          }
        }
        if (tipText) {
          if (Array.isArray(tipText)) {
            tipText.forEach(textItem => {
              tips.push({ filterItem, tipText: textItem.text, contentArr: textItem.contentArr, id: textItem.id });
            });
          } else {
            tips.push({ filterItem, tipText });
          }
        }
      });
      return tips;
    },
    formatFilterItem,
    getQuery(filterList) {
      const query = {
        ranges: [],
        not_paragraphs: [],
        contentConditionList: [],
        paragraphs: [],
        should_paragraphs: [],
        identities: [],
        not_stories: [],
        should_stories: [],
        stories: [],
        query_string: {},
        prop: {},
        props: {},
        propsLevel: {}
      };
      filterList.forEach(filterItem => {
        if (['全文检索'].includes(filterItem.name)) {
          const filterArr = [];
          let topType = 'must';
          filterItem.result.forEach(paragraphItem => {
            if (paragraphItem.value || paragraphItem.result.length) {
              // 包含高级检索和 输入框直接输入的
              const resItem = this.fullTextArgHandel(paragraphItem);
              if (!filterItem.bySearchInput && !filterArr.length) {
                topType = filterItem.type;
              }
              const fullTextItem = {
                type: paragraphItem.type || 'must', //兼容输入框插入的条件
                keyword: 'group',
                search_limit: '同篇',
                word: filterItem.word || '',
                field: 'para_content',
                children: resItem
              };

              filterArr.push(fullTextItem);
            }
          });

          if (filterArr.length) {
            query.contentConditionList.push({
              type: topType,
              keyword: 'group',
              search_limit: '同篇',
              word: '',
              field: 'para_content',
              children: filterArr
            });
          }
        } else if (['引用法条'].includes(filterItem.name)) {
          const contentQuery = {
            bool: {}
          };
          const key = filterItem.type == 'or' ? 'should' : 'must';
          contentQuery.bool[key] = [];
          const contentQueryArr = contentQuery.bool[key];
          filterItem.result.forEach(paragraphItem => {
            if (filterItem.name === '引用法条' && (paragraphItem.value || paragraphItem.keyword)) {
              contentQueryArr.push({
                regexp: {
                  'lawinfo.sentence': `.*?${paragraphItem.keyword}.*?${paragraphItem.value.slice(
                    0,
                    paragraphItem.value.indexOf('条') + 1
                  )}.*?`
                }
              });
            }
          });

          query.paragraphs.push(contentQuery);
        } else if (['fullreason'].includes(filterItem.key)) {
          // 兼容搜索框中插入的 结果中检索
          if (!query.propsLevel[filterItem.key]) {
            query.propsLevel[filterItem.key] = {
              default_operator: filterItem.type,
              keys: []
            };
          }
          query.propsLevel[filterItem.key].keys.push(
            ...filterItem.result
              .filter(o => o.value.length)
              .map(item => {
                return {
                  value: item.value.map(i => i.id)
                };
              })
          );
        } else if (['full_base_court', 'full_procedureType'].includes(filterItem.key)) {
          // 兼容搜索框中插入的 结果中检索
          if (!query.propsLevel[filterItem.key]) {
            query.propsLevel[filterItem.key] = {
              default_operator: 'OR',
              keys: [
                {
                  value: []
                }
              ]
            };
          }
          query.propsLevel[filterItem.key].keys[0].value.push(...filterItem.value.map(item => item.id));
        } else if (['base_courtLevel'].includes(filterItem.key)) {
          query.props[filterItem.key] = filterItem.value;
        } else if (['base_caseType', 'base_nature'].includes(filterItem.key)) {
          if (!filterItem.value.length) {
            return;
          }
          if (!query.props[filterItem.key]) {
            query.props[filterItem.key] = [];
          }
          query.props[filterItem.key].push(...filterItem.value);
        } else if (['fullreferencetype'].includes(filterItem.key)) {
          query.prop[filterItem.key] = filterItem.value;
        } else if (['base_title'].includes(filterItem.key) && filterItem.value) {
          query.query_string[filterItem.key] = filterItem.value;
        } else if (['base_caseNumber'].includes(filterItem.key) && filterItem.value) {
          query.props[filterItem.key] = filterItem.value.split('|');
        } else if (filterItem.key === 'judgementDate') {
          const rangesQuery = {};
          if (filterItem.value[0]) {
            rangesQuery.gte = moment(filterItem.value[0]).valueOf();
          }
          if (filterItem.value[1]) {
            rangesQuery.lte = moment(filterItem.value[1]).valueOf();
          }
          if (filterItem.value[0] || filterItem.value[1]) {
            query.ranges.push({
              range: 'judgementDate',
              query: rangesQuery
            });
          }
        } else if (filterItem.key === 'province_city') {
          filterItem.value.forEach(provinceCityItem => {
            if (provinceCityItem.length === 1) {
              if (!query.props.base_province) {
                query.props.base_province = [];
              }
              query.props.base_province.push(provinceCityItem[0]);
            }
            if (provinceCityItem.length === 2) {
              if (!query.props.base_city) {
                query.props.base_city = [];
              }
              query.props.base_city.push(provinceCityItem[1]);
            }
          });
        } else if (filterItem.key === 'mulit_personal_crime') {
          const { singlePersonal, mulitPersonal, singleCrime, mulitCrime } = filterItem.value;
          if (singlePersonal && mulitPersonal) {
            query.ranges.push({
              range: 'defendantSize',
              query: {
                gte: 1
              }
            });
          } else if (singlePersonal) {
            query.ranges.push({
              range: 'defendantSize',
              query: {
                lte: 1,
                gte: 1
              }
            });
          } else if (mulitPersonal) {
            query.ranges.push({
              range: 'defendantSize',
              query: {
                gte: 2
              }
            });
          }
          if (singleCrime && mulitCrime) {
            query.ranges.push({
              range: 'crime_reason_length',
              query: {
                gte: 1
              }
            });
          } else if (singleCrime) {
            query.ranges.push({
              range: 'crime_reason_length',
              query: {
                lte: 1,
                gte: 1
              }
            });
          } else if (mulitCrime) {
            query.ranges.push({
              range: 'crime_reason_length',
              query: {
                gte: 2
              }
            });
          }
        } else if (['律师', '律所', '当事人信息', '审判人员', '案情特征'].includes(filterItem.name)) {
          if (filterItem.value) {
            query.identities.push({
              userType: filterItem.name,
              name: filterItem.value
            });
          }
        }
      });
      return query;
    },
    fullTextArgHandel(item) {
      const arr = [];
      if (item.result && item.result.length) {
        item.result.forEach(i => {
          arr.push(...this.fullTextArgHandel(i));
        });
      } else {
        if (item.value) {
          const pushItem = {
            type: item.type,
            keyword: item.result && item.result.length ? 'group' : 'search',
            search_limit: item.searchLimit || '同篇',
            field: item.keyword || 'para_content'
          };
          if (item.value instanceof Array) {
            pushItem.terms = item.value.map(i => i.id);
            pushItem.word = '';
          } else {
            pushItem.word = item.value;
          }
          arr.push(pushItem);
        }
      }
      return arr;
    },
    fullTextShowHandel(item, paragraphArr) {
      const type = {
        must: '且',
        should: '或'
      };
      const arr = [];
      item.result.forEach(i => {
        if (i.result && i.result.length) {
          arr.push({
            id: i.id,
            text: this.fullTextShowHandel(i, paragraphArr)
              .map(i => {
                return i.text;
              })
              .join(` ${type[i.type]} `)
          });
        } else if (i.value instanceof Array) {
          // 兼容案由数组情况
          const paraEnum = {
            'fullreason.keyword': '案由'
          };
          if (i.value.length) {
            arr.push({
              id: i.id,
              text: `${paraEnum[i.keyword]} : ${i.value.map(i => i.name).join(' | ')}`
            });
          }
        } else if (i.value) {
          const paraItem = paragraphArr.find(paraItem => paraItem.key === i.keyword);
          const para = paraItem ? paraItem.value : '全文';
          i.searchLimit = i.searchLimit || '';
          // 同篇不显示这两个文字
          // 全文 : 同段 xxxxx
          const txt = `${para}${i.searchLimit === '同篇' ? '' : ` ${i.searchLimit}`} : ${i.value}`;
          arr.push({
            id: i.id,
            text: txt
          });
        }
      });

      return arr;
    },
    getFullTextList(item){
      const arr = [];
      if (item.result && item.result.length) {
        item.result.forEach(o => {
          arr.push(...this.getFullTextList(o));
        });
      } else if (item.value instanceof Array) {
        if (item.value.length) {
          arr.push(item);
        }
      } else if (item.value && item.value.trim()) {
        arr.push(item);
      }
      return arr
    },
    crimeEnum(type) {
      return {
        '1000': '单主体',
        '0100': '多主体',
        '0010': '单案由',
        '0001': '多案由',
        '1010': '单主体 + 单案由',
        '1001': '单主体 + 多案由',
        '0101': '多主体 + 多案由',
        '0110': '多主体 + 单案由',
        '1100': '单主体 | 多主体',
        '0011': '单案由 | 多案由',
        '1111': '(单主体 | 多主体) + (单案由 | 多案由)',
        '1110': '(单主体 | 多主体) + 单案由',
        '1011': '单主体 + (单案由 | 多案由)',
        '1101': '(单主体 | 多主体) + 多案由',
        '0111': '多主体 + (单案由 | 多案由)'
      } [type]
    },
    getLawParam({ categoryName = '' } = {}) {
      const param = {
        search: []
      };

      const lawOptionFilterList = JSON.parse(sessionStorage.getItem('lawOptionFilterList')) || [];
      lawOptionFilterList.forEach(i => {
        if(!i.value) return;
        if (['title', 'fulltext'].includes(i.key)) {
          i.value.split(' ').forEach((o, oIndex) => {
            param.search.push({
              f0: i.name,
              f1: o,
              f2: param.search.length,
              type: "normal"
            })
          })
          param[i.key] = i.value
        } else if (['docNum'].includes(i.key)) {
          param[i.key] = i.value.split(' ')
        } else if (['PubTime', 'ExecTime'].includes(i.key) && i.value.length) {
          param[`min${i.key}`] = i.value[0]
          param[`max${i.key}`] = i.value[1]
        } else if (['status', 'collect_status'].includes(i.key) && i.value.length) {
          param[i.key] = i.value
        } else if (['publishMachinery', 'classification'].includes(i.key) && i.value.length) {
          param[`full_${i.key}`] = i.value.map(o => o.id)
        } else if (['category'].includes(i.key) && i.value.length) {
          i.value.forEach(o => {
            if (!param[o.type]) {
              param[o.type] = []
            }
            param[o.type].push(o.name)
          })
        }
      })
      if (categoryName) {
        param.category = categoryName;
      }
      return param;
    },
    getLawTagList(filterList) {
      const list = [];
      filterList.forEach(i => {
        if (!i.value) return;
        const item = {
          key: i.key,
          name: i.name,
          type: i.type
        };
        if (i.type === 'string') {
          i.value
            .trim()
            .split(' ')
            .forEach(o => {
              list.push({ ...item, value: o });
            });
        } else if (i.type === 'date' && i.value.length) {
          list.push({ ...item, value: i.value.join(' - ') });
        } else if (i.type === 'array' && i.value.length) {
          i.value.forEach(o => {
            list.push({ ...item, value: o });
          });
        } else if (i.type === 'array-tree' && i.value.length) {
          i.value.forEach(o => {
            list.push({ ...item, value: o.name, id: o.id });
          });
        }
      });
      return list;
    }
  }
}

export function formatBlobToEext(blob) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener('loadend', e => {
      try {
        const result = e.target.result;
        if (!result) {
          throw new Error('解析失败');
        }
        resolve(JSON.parse(result));
      } catch (err) {
        resolve();
      }
    });
    reader.readAsText(blob);
  });
}

function formatFilterItem(info) {
  const delKeys = ['data', 'formatter'];
  delKeys.forEach(key => {
    if (info[key]) {
      delete info[key];
    }
  });
  return info;
}

export function addFilterOfCase(curFilterList, { name, curItem }, fullTree = {}) {
  curFilterList = [...curFilterList];
  let currentFilterIndex = curFilterList.findIndex(item => item.name === name || (item.subName || []).includes(name));
  const defaultFilterInfo = [...defaultFilterList, ...optionFilterList, ...otherFilterList].find(item => {
      return item.name === name || (item.subName || []).includes(name);
  });
  if (currentFilterIndex === -1) {
      if (!defaultFilterInfo) {
        return;
      }
      const info = _.cloneDeep(defaultFilterInfo);
      curFilterList.push(formatFilterItem(info));
      currentFilterIndex = curFilterList.length - 1;
  }
  const formatter = defaultFilterInfo && defaultFilterInfo.formatter || null;
  if (formatter) {
      const item = curFilterList[currentFilterIndex];
      if (name === '全文检索') {
        item.bySearchInput = true;
        item.result = [];
        formatter.call(item, {
          id: `${Date.now()}_${uniqueId()}`,
          keyword: '',
          value: curItem.key,
          word: curItem.key,
        });
      } else if (['审理程序','案由','地域及法院'].includes(name)){
          const curFullItem = (fullTree[name] || []).find(i=>i.id===curItem.id);
          if (!curFullItem) {
            return;
          }
          const {value,showValue} = childrenHandel(curFullItem,defaultFilterInfo.checkAllName);
          formatter.call(item, value, showValue);
      } else {
          let val = curItem.key;
          if (name === '案件类型') {
            val = val.split(',')
          }
          formatter.call(item, val);
      }
      return curFilterList;
  }
}

function childrenHandel(item,checkAllName){
  const value = [{name:item.name,id:item.id},...fetchAllChildArr(item.children)];
  const allName = item.level + 1 > checkAllName.length
          ? checkAllName[checkAllName.length - 1]
          : checkAllName[item.level];
  const name = item.children ? `${item.name} (${allName})`:item.name
  const showValue = [{name,id:item.id}];
  return {
      value,
      showValue
  }
}

function fetchAllChildArr(children = []) {
  const list = [...children];
  const arr = [];
  for (let i = 0; i < list.length; i++) {
      (list[i].children || []).forEach(o => {
          list.push(o);
      });
      arr.push({name: list[i].key ,id:list[i].id});
  }
  return arr;
}

export function isBlobReuqest(url = '') {
  if (url[0] === '/') {
    url = url.slice(1);
  }
  return blobRequestArr.some(blobUrl => url.indexOf(blobUrl) === 0);
}

export function findNodeByText(root, text) {
  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          return node.nodeValue.includes(text) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
        return NodeFilter.FILTER_SKIP;
      }
    }
  );
  const matches = [];
  let n;
  while ((n = walker.nextNode())) {
    matches.push(n.parentElement); // 返回包含该文本的元素
  }
  return matches; // 可能有多个
}


// WEBPACK FOOTER //
// ./src/common/js/publicUtil.js